import { faExclamation, faPen, faPlus, faSave, faTimes, faUndo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min'
import { Alert, Button, Card, CardBody, CardFooter, Col, Input, Label, Row } from 'reactstrap';
import { SUCCESS_RESPONSE } from '../../helpers/codeResponses/codes';
import handleErrorMessage from '../../helpers/errors/handleErrorMessage';
import withRedirect from '../../helpers/hoc/withRedirect'
import ButtonIcon from '../common/ButtonIcon';
import FalconCardHeader from '../common/FalconCardHeader';
import Flex from '../common/Flex';
import ComposeAttachment from '../complain/ComposeAttachment';
import { Toast } from '../UI/toast/Toast';
import { findOneSurvey, updateSurvey, removeOptionSurvey } from '../../helpers/api/survey';
import { useSelector } from 'react-redux';
import { isIterableArray, Message, Or, PreloadState } from '../UI/preloading/PreloadState';

const EditSurveys = ({ setRedirect, setRedirectUrl }) => {

    const history = useHistory();
    const { id } = useParams();
    const { selectedCondominium } = useSelector(state => state.condominium);

    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [options, setOptions] = useState([]);
    const [dueDate, setDueDate] = useState(null);
    const [tempOption, setTempOption] = useState('');
    const [attachments, setAttachments] = useState([]);
    const [filess, setFiles] = useState([]);
    const [submitting, setSubmitting] = useState(false);
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(null);
    const [cont, setCont] = useState(0);
    const mutate = () => setCont(cont + 1);

    useEffect(() => {
        let isMounted = true;
        const loadSurvey = async () => {
            try {
                const data = await findOneSurvey(id);
                isMounted && setData(data);
                isMounted && setTitle(data?.data?.voting_data.title);
                isMounted && setDescription(data?.data?.details);
                isMounted && setDueDate(data?.data?.voting_data.due_date);
                isMounted && setFiles(data?.data?.files);
                let array_temp = [];
                data?.data?.options?.forEach((option) => { array_temp.push(option.option); });
                isMounted && setOptions(array_temp);
            } catch (error) {
                handleErrorMessage(error);
            } finally {
                isMounted && setLoading(false);
            }
        }
        loadSurvey();
        return () => {
            isMounted = false;
            setOptions([]);
            setFiles([]);
            setAttachments([]);
        }
        // eslint-disable-next-line
    }, [cont]);

    const handleDetachAttachment = (id, index) => {
        setAttachments(attachments.filter(attachment => id !== attachment.id))
        setFiles(filess.filter((file, i) => i !== index));
    }

    const saveInteraction = async () => {
        setSubmitting(true);
        const formdata = new FormData();
        formdata.append('id', data?.data?.voting_data?.id);
        formdata.append('title', title);
        formdata.append('survey', data?.data?.voting_data?.survey);
        formdata.append('details', description);
        formdata.append('due_date', data?.data?.voting_data?.due_date);

        options.forEach((option, i) => {
            formdata.append(`options[${i}]`, option);
        });

        filess.forEach((file, i) => formdata.append(`files[${i}]`, file));

        updateSurvey(selectedCondominium, formdata)
            .then(({ code }) => {
                if (code === SUCCESS_RESPONSE.OK) {
                    Toast.fire({ title: 'Actualizado exitosamente', type: 'success' });
                    history.push('/dashboard/surveys');
                }
            })
            .catch(error => {
                handleErrorMessage(error);
            }).finally(() => setSubmitting(false));
    }


    const dropOptions = async (id) => {
        try {
            const res = await removeOptionSurvey(id);
            if (res.code === SUCCESS_RESPONSE.OK) {
                mutate();
                Toast.fire({ title: `Opcion eliminada`, type: 'success' });
                setOptions(options.filter((val, index) => id !== index));
            }
        } catch (error) {
            handleErrorMessage(error);
        }
    }

    return <>
        <Card>
            <FalconCardHeader title={data?.data?.voting_data?.survey === '1' ? 'Edicion de encuesta' : 'Edicion de votación'} />
            <PreloadState cond={!!data} loading={loading || submitting} message={submitting ? 'Guardando...' : ''}>
                <Or value={true}>
                    <CardBody className='p-0'>
                        <div className="border-bottom border-200">
                            <Input readOnly={true} type='text' className='border-0 outline-none px-card' value={title} onChange={({ target }) => setTitle(target.value)} placeholder='Título' />
                        </div>
                        <div className="border-bottom border-200">
                            <Input readOnly={true} type='text' className='border-0 outline-none px-card' value={description} onChange={({ target }) => setDescription(target.value)} placeholder='Descripción' />
                        </div>
                        <div>
                            <Flex className='align-items-center border-bottom border-200'>
                                <FontAwesomeIcon className='mx-3' icon={faPen} />
                                <Input placeholder='Escriba una opción' type='text' className='border-0 outline-none px-card border-bottom' value={tempOption} onChange={({ target }) => setTempOption(target.value)} />
                                <ButtonIcon className='shadow-none' icon={faPlus} disabled={!tempOption} style={{ whiteSpace: 'nowrap' }} size='md' color='falcon-default' onClick={() => {
                                    setOptions(prev => [...prev, tempOption]);
                                    setTempOption('');
                                }} >Agregar opción</ButtonIcon>
                            </Flex>
                        </div>
                        <div className='px-3 pt-3'>
                            <Row>
                                <Col xs={12}>
                                    <Label className='ml-2 '>Opciones:</Label>
                                </Col>
                                <Or cond={isIterableArray(options)}>
                                    <Or value={true}>
                                        <Col xs={12}>
                                            {options.map((val, i) => {
                                                return <div key={i}>
                                                    {i !== 0 && <hr className='p-0 m-0' />}
                                                    <span className='text-muted'><Button color='falcon-default' className='shadow-none' onClick={() => dropOptions(i)} ><FontAwesomeIcon icon={faTimes} /></Button> {val}</span>
                                                </div>
                                            })
                                            }
                                        </Col>
                                    </Or>
                                    <Or value={false}>
                                        <Col xs={12} className='text-center pt-3'>
                                            <Alert color='warning'>
                                                <FontAwesomeIcon icon={faExclamation} /> Asegurese de registrar al menos dos opciones.
                                            </Alert>
                                        </Col>
                                    </Or>
                                </Or>
                            </Row>
                        </div>
                        <div className='px-3 pt-3'>
                            <Row>
                                <Col xs={12}>
                                    <Label className='ml-2 '>Fecha de expiración:</Label>
                                </Col>
                                <Col xs={12} className='px-0'>
                                    <Input readOnly={true} value={dueDate} style={{ boxShadow: 'none', border: 'none' }} />
                                </Col>
                            </Row>
                        </div>

                        <div className='px-3 pt-3'>
                            <Row>
                                <Col>
                                    <Label className='ml-2 '>Archivos adjuntos:</Label>
                                </Col>
                                <Or cond={isIterableArray(attachments)}>
                                    <Or value={true}>
                                        <Col>
                                            {attachments.map((attachment, i) => (
                                                <ComposeAttachment
                                                    {...attachment}
                                                    key={attachment.id}
                                                    index={i}
                                                    handleDetachAttachment={handleDetachAttachment}
                                                />
                                            ))}
                                        </Col>
                                    </Or>
                                    <Message value={false} icon={faExclamation} className='m-2 pb-3'>No hay archivos adjuntos para mostrar</Message>
                                </Or>
                            </Row>
                        </div>

                    </CardBody>
                    <CardFooter>
                        <Flex justify='end' align="center">
                            <ButtonIcon icon={faUndo} color="light" onClick={() => history.goBack()} size="sm" className="px-5 mr-2" type="button">
                                Volver
                            </ButtonIcon>
                            <ButtonIcon icon={faSave} onClick={saveInteraction} color="primary" size="sm" className="px-5 mr-2" type="button">
                                Actualizar {data?.data?.voting_data?.survey === '1' ? 'encuesta' : 'votación'}
                            </ButtonIcon>
                        </Flex>
                    </CardFooter>
                </Or>
                <Message value={false} icon='info'>No hay datos para mostrar</Message>
            </PreloadState>
        </Card>
    </>
}

export default withRedirect(EditSurveys);